const TILES_PER_ROW = 3;
const GRID_COLUMNS = 12;

export interface TileColumnWidthProps {
  tileCount: number;
  index: number;
}

/*
Grid columns for one stat tile, so every row fills the container edge to edge:
three tiles to a full row, and a trailing short row shared out between whatever
is left over. Six tiles sit 3 + 3, five sit 3 + 2, and a count the stats ever
grow to is laid out by the same rule rather than by a special case.
*/
export function tileColumnWidth(props: TileColumnWidthProps): number {
  const { tileCount, index } = props;

  const fullRowTileCount = tileCount - (tileCount % TILES_PER_ROW);
  const isInTrailingRow = index >= fullRowTileCount;

  if (!isInTrailingRow) {
    return GRID_COLUMNS / TILES_PER_ROW;
  }

  return GRID_COLUMNS / (tileCount - fullRowTileCount);
}
